<template>
  <section id="admin-filter">
    <h4>Transit Miles filter</h4>
    <div class="form-group">
      <label class="form-label">Origin Location</label>
      <autocomplete
        :dataset="locationSearchResults"
        title="Origin Location"
        placeHolder="Type to search"
        :initVal="entity.originLocation"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectOrigin"
      ></autocomplete>
    </div>
    <div class="form-group">
      <label class="form-label">Destination Location</label>
      <autocomplete
        :dataset="locationSearchResults"
        title="Origin Location"
        placeHolder="Type to search"
        :initVal="entity.destinationLocation"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectDestination"
      ></autocomplete>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  export default {
    name: 'TransitMileFilter',
    mixins: [ FilterMixin, HelperMixin ],
    data () {
      return {
        entity: {
          originLocation: '',
          destinationLocation: ''
        }
      }
    },
    components: {
      Autocomplete
    },
    methods: {
      selectOrigin (o) {
        this.entity.originLocation = o
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      selectDestination (d) {
        this.entity.destinationLocation = d
        this.locationSearchText = ''
        this.locationSearchResults = []
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// TransitMileFilter.vue?7e9f40d6